import React from 'react';
import { IReceiptData } from '../../../ApiCalls';
import DateTimeInput from './Forms/DateTimeInput';
import ProgressBar from './Forms/ProgressBar';
import TextInput from './Forms/TextInput';
import CurrencyInput from './Forms/CurrencyInput';
import SelectInput from './Forms/SelectInput';
import { GlobalVariables } from '../../../GlobalVariables';
import VerticalStretch from './Forms/VerticalStretch';
import { useSelector } from 'react-redux';
import { checkReceiptData } from '../Helpers';
import { documentLoadingErrorState } from '../../../redux/slices/statusesSlice';
import { ReduxUpdater } from '../../../redux/ReduxUpdater';
import { receiptChangesState } from '../../../redux/slices/receiptChangesSlice';
import NavButtonsGroup from './Forms/NavButtonsGroup';
import ConfirmAndNextAdminMenu from './AdminMenu';
import { FilterCategories } from '../../../Shared';

export interface IConfirmAndNextUnmatchedFormProps {
    idx: number;
    max: number;
    receipt: IReceiptData;
    onConfirm: () => void;
    onSave: () => void;
    onPrev: () => void;
    onNext: () => void;
    onMark: () => void;
}

const ConfirmAndNextUnmatchedForm = (props: IConfirmAndNextUnmatchedFormProps) => {
    const currentImageLoadingErrorState = useSelector(documentLoadingErrorState);
    const receiptChanges = useSelector(receiptChangesState);
    
    const { idx, max, receipt, onConfirm, onPrev, onNext, onMark, onSave } = props;

    const [doFilter, setDoFilter] = React.useState(true);

    console.log('ConfirmAndNextUnmatchedForm:', receipt, receiptChanges);

    const date = receiptChanges.transaction_date ?? receipt.transaction_date;
    const TS = Date.now();
    const ID = `${receipt.id}-${TS}`;
    const mergedData = {
        ...receipt,
        ...receiptChanges,
    };

    const handleConfirm = () => {
        if (checkReceiptData(mergedData, GlobalVariables.coOwnersExtendedArray, currentImageLoadingErrorState)) {
            onConfirm();
        }
    }

    const handleSave = () => {
        setTimeout(() => {
            onSave();
        }, 250);
    }

    const handleRevert = () => {
        ReduxUpdater.receiptChanges = {} as IReceiptData;
    }

    GlobalVariables.allowReceiptChanges = false;
    React.useEffect(() => {
        // console.log('Reset values');
        // ReduxUpdater.receiptChanges = {} as IReceiptData;
        setTimeout(() => {
            GlobalVariables.allowReceiptChanges = true;
        }, 250);
    });

    const showAll = receipt.user_description && receipt.user_description.toLowerCase().indexOf('food') !== -1;
    const filteredCategories = React.useMemo(() => {
        return FilterCategories(receipt, doFilter);
    }, [doFilter, receipt]);

    return (
        <div id={`confirmAndNextUnmatchedForm-${ID}`} className="h-[100%] w-full inline-flex flex-col justify-start items-start gap-4 relative">
            {ConfirmAndNextAdminMenu(receipt)}
            <DateTimeInput
                type={date === null || date === '' ? 'warning' : 'edit'}
                label="Date / Time"
                receipt={mergedData}
                onUpdate={(newDate) => {
                    if (GlobalVariables.allowReceiptChanges && mergedData.transaction_date !== newDate) {
                        console.log(`transaction_date CHANGES3: |${mergedData.transaction_date}|${newDate}|`);
                        ReduxUpdater.receiptChanges = {
                            ...receiptChanges,
                            id: receipt.id,
                            message_id: receipt.message_id,
                            transaction_date: newDate,
                            transaction_time: null,
                        };
                    }
                }}
            />
            <TextInput
                idx={`merchant-${ID}`}
                type={![null, ''].includes(mergedData.vendor_name) ? 'edit' : 'empty'}
                label="Merchant"
                value={mergedData.vendor_name ?? ''}
                onChange={(newValue) => {
                    if (GlobalVariables.allowReceiptChanges && receipt.vendor_name !== newValue) {
                        console.log(`vendor_name CHANGES3: |${receipt.vendor_name}|${newValue}|`);
                        ReduxUpdater.receiptChanges = {
                            ...receiptChanges,
                            id: receipt.id,
                            message_id: receipt.message_id,
                            vendor_name: newValue,
                        };
                    }
                }}
            />
            <CurrencyInput
                idx={`amount-${ID}`}
                type={mergedData.amount !== null && mergedData.amount !== '' && mergedData.currency !== '' && mergedData.currency !== null ? 'edit' : 'empty'}
                label="Amount"
                amount={mergedData.amount ?? ''}
                currency={mergedData.currency ?? ''}
                onChange={(amount, currency) => {
                    if (GlobalVariables.allowReceiptChanges && (receipt.amount !== amount || receipt.currency !== currency)) {
                        console.log(`amount CHANGES3: |${receipt.amount}|${amount}|`);
                        console.log(`currency CHANGES3: |${receipt.currency}|${currency}|`);
                        ReduxUpdater.receiptChanges = {
                            ...receiptChanges,
                            id: receipt.id,
                            message_id: receipt.message_id,
                            amount: amount,
                            currency: currency,
                        };
                    }
                }}
            />
            <TextInput
                idx={`receiptStatus-${ID}`}
                type="warning"
                label="Receipt Status"
                value="Awaiting Transaction Sync"
                titleOrAction={
                    <button
                        className="text-text-action-button"
                        onClick={onMark}
                    >
                        Mark as boat cash
                    </button>
                }
            />
            <TextInput 
                idx={`userDescription-${ID}`}
                type="edit"
                label="User Description"
                value={mergedData.user_description ?? ''}
                onChange={(newValue) => {
                    if (GlobalVariables.allowReceiptChanges && (receipt.user_description ?? '') !== newValue) {
                        console.log(`user_description CHANGES3: |${receipt.user_description ?? ''}|${newValue}|`);
                        ReduxUpdater.receiptChanges = {
                            ...receiptChanges,
                            id: receipt.id,
                            message_id: receipt.message_id,
                            user_description: newValue,
                        };
                    }
                }}
            />
            <SelectInput 
                idx={`category-${ID}`}
                type={mergedData.maris_category_id !== null ? 'edit' : 'empty'}
                label="Category"
                value={(mergedData.maris_category_id ?? -1).toString()}
                options={filteredCategories}
                selectClasses=''
                onChange={(newValue) => {
                    if (GlobalVariables.allowReceiptChanges && receipt.maris_category_id !== parseInt(newValue)) {
                        console.log(`maris_category_id CHANGES3: |${receipt.maris_category_id}|${newValue}|`);
                        ReduxUpdater.receiptChanges = {
                            ...receiptChanges,
                            id: receipt.id,
                            message_id: receipt.message_id,
                            maris_category_id: parseInt(newValue),
                        };
                    }
                }}
                titleOrAction={showAll && doFilter
                    ? 
                        <button
                            className="text-text-action-button"
                            onClick={() => setDoFilter(false)}
                        >
                            Show all
                        </button> 
                    : ''
                }
            />
            {GlobalVariables.coOwners.length > 1 && <SelectInput
                idx={`coOwner-${ID}`}
                type="edit"
                label="Co-owner Expense Allocation"
                value={mergedData.co_owner_name ?? ''}
                options={GlobalVariables.coOwnersExtendedArray}
                onChange={(newValue) => {
                    if (GlobalVariables.allowReceiptChanges && receipt.co_owner_name !== newValue) {
                        ReduxUpdater.receiptChanges = {
                            ...receiptChanges,
                            id: receipt.id,
                            message_id: receipt.message_id,
                            co_owner_name: newValue,
                        };
                    }
                }}
            />}
            <VerticalStretch />
            <ProgressBar value={idx+1} max={max} />
            <NavButtonsGroup label="Next" tooltip="Awaiting sync transactions cannot be confirmed" max={max} onRevert={handleRevert} onSave={handleSave} onPrev={onPrev} onConfirm={handleConfirm} onNext={onNext} />
        </div>
    );
};

export default ConfirmAndNextUnmatchedForm;